<section class="page-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin Dashboard</span>
        <h1>IOSC website management.</h1>
        <p>Manage products, certificates and contact requests.</p>
    </div>
</section>

<section class="section admin-section">
    <div class="container">

        <div class="admin-top-actions">
            <a class="learn" routerLink="/">← View website</a>

            <button class="btn btn-dark" type="button" (click)="logout()">
                Logout
            </button>
        </div>

        <div class="capability-grid">
            <article class="cap-card reveal show">
                <h3>Home Page</h3>
                <p>Manage hero, metrics, trust items, industries, cases and features.</p>
                <a class="learn" routerLink="/admin/home">Open home admin →</a>
            </article>

            <article class="cap-card reveal show">
                <h3>About Page</h3>
                <p>Manage about hero, company profile, features and timeline.</p>
                <a class="learn" routerLink="/admin/about">Open about admin →</a>
            </article>

            <article class="cap-card reveal show">
                <h3>Services</h3>
                <p>Manage service cards, descriptions, icons and CTA links.</p>
                <a class="learn" routerLink="/admin/services">Open services admin →</a>
            </article>

            <article class="cap-card reveal show">
                <h3>Products</h3>
                <p>Manage product catalog, categories and product images.</p>
                <a class="learn" routerLink="/admin/products">Open products →</a>
            </article>

            <article class="cap-card reveal show">
                <h3>Certificates</h3>
                <p>Upload PDF certificates and manage document library.</p>
                <a class="learn" routerLink="/admin/certificates">Open certificates →</a>
            </article>

            <article class="cap-card reveal show">
                <h3>Contact Requests</h3>
                <p>View customer RFQ and contact submissions.</p>
                <a class="learn" routerLink="/admin/contact-requests">Open requests →</a>
            </article>

            <article class="cap-card reveal show">
                <h3>Social Links</h3>
                <p>Manage LinkedIn, Facebook, Instagram, YouTube and email links.</p>
                <a class="learn" routerLink="/admin/social-links">Open social links →</a>
            </article>
        </div>

    </div>
</section>